<template>
  <tr class="invoice-item-row" :class="{adding: !item || isEditing}">
    <td>
      <v-select v-if="isEditing" :options="invoiceItemTypes" :searchable="false" :clearable="true" v-model="type" :reduce="item => item.value" placeholder="- Select"></v-select>
      <span :class="item?'lb-' + item.type:''" v-else>{{ item?item.type:'' | statusToUCWords }}</span>
    </td>
    <td>
      <v-select v-if="isEditing" v-model="cost_category_id" :options="allCostCategories" class="form-control" :reduce="item => item.id"
                label="name" :searchable="true" :clearable="false" :placeholder="'- Select'"></v-select>
      <span v-else>{{ item && item.cost?item.cost.category.name:'' }}</span>
    </td>
    <td>
      <v-select v-if="isEditing" v-model="cost_matrix_id" :options="filteredCostRecords" class="form-control" :reduce="item => item.id"
                label="description" :searchable="true" :placeholder="'- Cost item'"></v-select>
      <span v-else>{{ item && item.cost?item.cost.description:'' }}</span>
    </td>
    <td>
      <textarea v-if="isEditing" id="description" type="text" class="form-control" rows="2" placeholder="Description" v-model="description"></textarea>
      <span v-else>{{ item && item.description }}</span>
    </td>
    <td>
      <input v-if="isEditing" type="text" name="quantity" id="quantity" class="form-control" v-model="quantity">
      <span v-else>{{ item && item.quantity }}</span>
    </td>
    <td>
      <input v-if="isEditing" type="text" name="rate" id="rate" class="form-control" v-model="rate">
      <span v-else>{{ item && item.rate | moneyFormat }}</span>
    </td>
    <td><span>{{ invoicedAmount | moneyFormat }}</span></td>
    <td><span>{{ invoicedGTSAmount | moneyFormat }}</span></td>
    <td><span>{{ invoicedInclGTSAmount | moneyFormat }}</span></td>
    <td align="right">
      <beat-loader v-if="state == 'saving'"></beat-loader>
      <template v-else>
        <div v-if="isEditing">
          <a href="javascript:;" class="icon-checkmark" v-tooltip="'Save item'"
             @click="saveItem()"></a>&nbsp;
          <a href="javascript:;" class="icon-close" v-tooltip="'Cancel'"
             @click="cancelItem()"></a>
        </div>
        <div v-else>
          <a href="javascript:;" class="icon-pencil" v-tooltip="'Edit item'" @click="isEditing = true"></a>&nbsp;
          <a href="javascript:;" class="icon-trash" v-tooltip="'Remove item'" @click="confDelete"></a>
        </div>
      </template>
    </td>
  </tr>
</template>

<script>
  import { mapState } from 'vuex'
  import BeatLoader from 'vue-spinner/src/BeatLoader'
  import Service from '@/services/invoice'

  export default {
    components: {
      BeatLoader,
    },
    data () {
      return this.initialState();
    },
    props: ['item', 'idx'],
    computed: {
      ...mapState({
        allCostRecords: state => state.option.costs,
        allCostCategories: state => state.option.costCategories,
        invoiceItemTypes: state => state.option.invoiceItemTypes,
        invoice: state => state.invoice.invoice
      }),
      filteredCostRecords() {
        let self = this, records = [];
        for(let i in self.allCostRecords) {
          if(self.allCostRecords[i].category_id == self.cost_category_id) {
            records.push(self.allCostRecords[i]);
          }
        }
        return records;
      },
      invoicedAmount() {
        if (this.isEditing)
          return parseFloat(this.rate)*parseFloat(this.quantity);
        else
          return parseFloat(this.item.amount);
      },
      invoicedGTSAmount() {
        if (this.isEditing)
          return parseFloat(this.rate)*parseFloat(this.quantity)*0.1;
        else
          return parseFloat(this.item.amount)*0.1;
      },
      invoicedInclGTSAmount() {
        if (this.isEditing)
          return parseFloat(this.rate)*parseFloat(this.quantity)*1.1;
        else
          return parseFloat(this.item.amount)*1.1;
      }
    },
    watch: {
      cost_matrix_id ( newVal ) {
        if ( newVal ) {
          let self = this, cost_item = window.getObjectByKeyValue(self.allCostRecords, 'id', newVal);
          if (cost_item) {
            if (!self.rate) {
              self.rate = cost_item.sell_tier1;
              self.amount = parseFloat(self.rate)*parseFloat(self.quantity);
            }
          }
        }
      },
      quantity (newVal) {
        if ( newVal ) {
          let self = this;
          if (self.rate) {
            self.amount = parseFloat(self.rate)*parseFloat(self.quantity);
          }
        }
      }
    },
    mounted () {
      this.init();
    },
    methods: {
      initialState (){
        return {
          state: '',
          cost_category_id: 1,
          cost_matrix_id: '',
          quantity: '',
          description: '',
          amount: 0,
          rate: '',
          type: '',
          isEditing: false
        }
      },
      loadItem () {
        let self = this;
        if ( !self.item ) {
          return;
        }
        if (self.item.cost)
          self.cost_category_id = self.item.cost.category_id;
        self.cost_matrix_id = self.item.cost_matrix_id;
        self.quantity = self.item.quantity;
        self.rate = self.item.rate;
        self.description = self.item.description;
        self.amount = self.item.amount;
        self.type = self.item.type;
      },
      init () {
        let self = this;
        Object.assign(this.$data, this.initialState());
        if ( !self.item ) {
          self.isEditing = true;
          return;
        }
        self.loadItem();
      },
      saveItem ( ) {
        let self = this;

        if ( self.state == 'saving' ) {
          return;
        }

        let postData = {};

        if ( !self.item || self.cost_matrix_id != self.item.cost_matrix_id )
          postData.cost_matrix_id = self.cost_matrix_id;

        if ( !self.item || self.quantity != self.item.quantity )
          postData.quantity = self.quantity;

        if ( !self.item || self.rate != self.item.rate )
          postData.rate = self.rate;

        if ( !self.item || self.description != self.item.description )
          postData.description = self.description;

        if ( !self.item || self.amount != self.item.amount )
          postData.amount = self.amount;

        if ( !self.item || self.type != self.item.type )
          postData.type = self.type;

        if (!self.isValid())
          return false;

        self.state = 'saving';
        if(self.item) {
          Service.saveItem(self.invoice.id, self.item.id, postData, itemData => {
            self.state = '';
            if(typeof itemData.status != 'undefined' && itemData.status == 'FAILED'){
              self.$notify({
                type: 'error',
                text: itemData.error
              });
            }else{
              self.$notify({
                type: 'success',
                text: 'Invoice item updated successfully'
              });
              self.$emit('item-saved', itemData, self.idx);
              Object.assign(self.item, itemData);
              self.init();
            }
          }, () => {
            self.state = '';
          });
        }else{
          Service.createItem(self.invoice.id, postData, itemData => {
            self.state = '';
            if(typeof itemData.status != 'undefined' && itemData.status == 'FAILED'){
              self.$notify({
                type: 'error',
                text: itemData.error
              });
            }else {
              self.$notify({
                type: 'success',
                text: 'Invoice item created successfully'
              });
              self.$emit('item-saved', itemData, self.idx);
              self.item = itemData;
              self.init();
            }
          }, () => {
            self.state = '';
          });
        }
      },
      isValid() {
        let self = this, requiredFields = {
          'cost_matrix_id': 'Please select the cost item',
          'description': 'Please enter the description'
        };
        for(let f in requiredFields) {
          if (!self[f]) {
            self.$notify({
              type: 'error',
              text: requiredFields[f]
            });
            return false;
          }
        }
        return true;
      },
      cancelItem () {
        if (this.item) {
          this.loadItem(this.item);
          this.isEditing = false;
        } else {
          Object.assign(this.$data, this.initialState());
          this.$emit('item-cancelled');
        }
      },
      confDelete () {
        let self = this, item = self.item;
        self.$dialog
          .confirm('Are you sure you want to delete this item?', {
            html: true,
            loader: true,
            okText: "Yes, I'm sure",
            cancelText: "Cancel",
          })
          .then(dialog => {
            Service.deleteItem(item.invoice_id, item.id, (data) => {
              dialog.close();
              if(data.status == 'FAILED'){
                self.$notify({
                  type: 'error',
                  text: data.error
                });
              }else {
                self.$emit('item-deleted', self.idx);
              }
            });
          })
          .catch(() => {});
      }
    }
  }
</script>
